import useApiWorker from 'hooks/useApiWorker';
import { Group, GroupIdentifier } from 'types/group';

const defaultErrorResponse: ApiResponse<Group> = {
  success: false,
  message: 'An error occurred',
};

export async function ListGroups(): Promise<ApiListResponse<GroupIdentifier>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<Array<GroupIdentifier>>(`/groups`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function GetGroup(groupName: string): Promise<ApiResponse<Group>> {
  const apiWorker = useApiWorker();
  return apiWorker
    .get<Group>(`/groups/${groupName}`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return { success: false, message: error.response.data.message };
    });
}

export async function AddGroup(group: Group): Promise<ApiResponse<Group>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .post<Group>(`/groups`, group)
    .then(() => {
      return { success: true, group };
    })
    .catch((error) => {
      return {
        group,
        errors: error.response.data,
        ...defaultErrorResponse,
      };
    });
}

export async function UpdateGroup(groupName: string, group: Group): Promise<ApiResponse<Group>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .put<Group>(`/groups/${groupName}`, group)
    .then(() => {
      return { success: true, group };
    })
    .catch((error) => {
      return {
        group,
        errors: error.response.data,
        ...defaultErrorResponse,
      };
    });
}

export async function DeleteGroup(group: Group): Promise<ApiResponse<Group>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .delete(`/groups/${group.Name}`)
    .then(() => {
      return { success: true, group };
    })
    .catch((error) => {
      return { success: false, message: error.response.data };
    });
}
